module.exports = __webpack_public_path__ + "assets/img/warrior-name-3ab10a28.png";